function sizeGuideDrawer() {
  return {
    isOpen: false,
    activeTab: "size-guide",

    toggle() {
      this.isOpen = !this.isOpen;
    },

    init() {
      this.$watch("isOpen", (value) => {
        if (value) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "";
        }
      });
    }
  };
}

export default sizeGuideDrawer;
